import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import { GameIntroScene } from './scenes/GameIntro';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';

interface PhaserFacePaintingGameProps {
    onComplete: () => void;
}

interface PhaserFacePaintingGameState {
}

const gameConfig: GameConfig = {
    title: "Face Painting Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserFacePaintingGame extends React.Component<PhaserFacePaintingGameProps, PhaserFacePaintingGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserFacePaintingGameProps) {
        super(props);
        bindAllOfThis(this, PhaserFacePaintingGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserFacePaintingGame;



// WEBPACK FOOTER //
// ./src/games/FacePainting/Main.tsx